import { registerEventHandler } from 'reffects';
import { state } from 'reffects-store';
import { globals, http } from 'reffects-batteries';
import registerConfigEvents from 'events/configs';
import registerFeatureEvents from 'events/features';

export default function registerEvents() {
  registerEventHandler(
    'INITIALIZE_STATE',
    function initializeState(_, payload) {
      return state.set(payload);
    },
    []
  );

  registerEventHandler(
    'SET_RIGHTS_TO_STATE',
    function initializeState({ globals: { trovitData } }) {
      if (trovitData == null) {
        return {};
      }
      const { rights } = trovitData;

      if (rights == null) {
        return {};
      }

      return state.set({ rights });
    },
    [globals.get('trovitData')]
  );

  registerEventHandler(
    'SET_INIT_TIME_TO_STATE',
    function initializeState({ globals: { trovitData } }) {
      if (trovitData == null) {
        return {};
      }
      const initTime = Date.now();

      if (initTime == null) {
        return {};
      }

      return state.set({ initTime });
    },
    [globals.get('trovitData')]
  );

  registerEventHandler(
    'SEND_INIT_TIME',
    function sendInitTime({ state: { initTime } }) {
      const nowMilliseconds = Date.now();
      const initTimeInMilliseconds = Math.abs(nowMilliseconds - initTime);
      return http.get({
        url: `/index.php/api/metricsender/timing/${initTimeInMilliseconds}`,
        successEvent: ['SEND_INIT_TIME_SUCCESS'],
        errorEvent: ['SEND_INIT_TIME_FAILED'],
      });
    },
    [state.get({ initTime: 'initTime' })]
  );

  registerEventHandler(
    'SEND_INIT_TIME_SUCCESS',
    function sendInitTimeSuccess() {
      console.log(`LoadTime sent`);
    },
    []
  );

  registerEventHandler(
    'INITIALIZE_TROVIT_DATA',
    function initializeTrovitData(coeffect) {
      const {
        globals: { trovitData },
      } = coeffect;

      return state.set({ trovitData });
    },
    [globals.get('trovitData')]
  );

  registerConfigEvents();
  registerFeatureEvents();
}
